import { format } from 'date-fns'

export const isRiskProfileExpired = (validTo?: null | string) => {
  if (!validTo) return true

  return validTo < format(new Date(), 'yyyy-MM-dd')
}
